import React from 'react';

const TextLabel = (props) => {
    return (
        <p className="">
            {props.label}
            {(props.isRequired) && (
                <span className="p-badge-required">必須</span>
            )}
        </p>
    )
};

export default TextLabel